import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IRaporv2YuklemeListeOzet_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IRaporv2YuklemeListeOzet_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Date: any[];
  Get_Date_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  Rprv2_YuklemeListeOzet: any[];
  Rprv2_YuklemeListeOzet_dummy: any[];
  Rprv2_YuklemeListeOzet_Export: any[];
  Rprv2_YuklemeListeOzet_Export_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
}

export class Raporv2YuklemeListeOzet_ScreenBase extends React.PureComponent<
  IRaporv2YuklemeListeOzet_ScreenProps,
  any
> {
  raporv2yuklemelisteozet_129888_value_kuikaDateRef: React.RefObject<any>;
  raporv2yuklemelisteozet_140956_value_kuikaDateRef: React.RefObject<any>;
  raporv2yuklemelisteozet_559033_value_kuikaTableRef: React.RefObject<any>;
  raporv2yuklemelisteozet_576980_value_kuikaDatetimeRef: React.RefObject<any>;
  raporv2yuklemelisteozet_714715_value_kuikaDatetimeRef: React.RefObject<any>;
  raporv2yuklemelisteozet_107877_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "6679b9ab-f91c-4d4c-9e54-1b2885e96352",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 980166,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        {
          Id: 162294,
          PropertyName: "value",
          Value: "YÜKLEME EMRİ TAKİP LİSTESİ",
        },
        { Id: 186535, PropertyName: "label", Value: "Excel Kaydet" },
        { Id: 755618, PropertyName: "value", Value: "TARİH ARALIĞI SEÇİNİZ" },
        { Id: 129888, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 140956, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 111189, PropertyName: "label", Value: "Yenile" },
        { Id: 145261, PropertyName: "title", Value: "İşlemler" },
        { Id: 499902, PropertyName: "title", Value: "Tarih" },
        {
          Id: 576980,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 159875, PropertyName: "title", Value: "Planlanan Tarih" },
        {
          Id: 714715,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 481356, PropertyName: "title", Value: "Gerçekleşen Tarih" },
        {
          Id: 107877,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 510557, PropertyName: "title", Value: "Ref Yükleme No" },
        {
          Id: 918217,
          PropertyName: "value",
          Value: "[datafield:referansyuklemeno]",
        },
        { Id: 408516, PropertyName: "title", Value: "Yükleme No" },
        { Id: 307294, PropertyName: "value", Value: "[datafield:yuklemeno]" },
        { Id: 394164, PropertyName: "title", Value: "Çıkış Yeri" },
        { Id: 701023, PropertyName: "value", Value: "[datafield:cikisyeri]" },
        { Id: 42704, PropertyName: "title", Value: "Taşıyıcı Firma" },
        {
          Id: 730621,
          PropertyName: "value",
          Value: "[datafield:tasiyicifirmaadi]",
        },
        { Id: 768361, PropertyName: "title", Value: "Araç Tipi" },
        { Id: 804461, PropertyName: "value", Value: "[datafield:aractipi]" },
        { Id: 594310, PropertyName: "title", Value: "Nokta Sayısı" },
        { Id: 96853, PropertyName: "value", Value: "[datafield:noktasayisi]" },
        { Id: 121408, PropertyName: "title", Value: "Toplam Ağırlık" },
        {
          Id: 629871,
          PropertyName: "value",
          Value: "[datafield:toplamagirlik]",
        },
        { Id: 619123, PropertyName: "title", Value: "Plaka" },
        { Id: 924550, PropertyName: "value", Value: "[datafield:plaka]" },
        { Id: 440379, PropertyName: "title", Value: "Sürücü Adı" },
        { Id: 14457, PropertyName: "value", Value: "[datafield:surucuadi]" },
        { Id: 997454, PropertyName: "title", Value: "Sürücü Gsm" },
        { Id: 434788, PropertyName: "value", Value: "[datafield:surucugsm]" },
        { Id: 705838, PropertyName: "title", Value: "Durum" },
        { Id: 290148, PropertyName: "value", Value: "[datafield:aracdurum]" },
        { Id: 727961, PropertyName: "title", Value: "Sürücü Kimlik No" },
        { Id: 690313, PropertyName: "value", Value: "[datafield:surucutckn]" },
        { Id: 430703, PropertyName: "title", Value: "İl" },
        { Id: 363067, PropertyName: "value", Value: "[datafield:varisil]" },
        { Id: 304534, PropertyName: "title", Value: "İlçe" },
        { Id: 769206, PropertyName: "value", Value: "[datafield:varisilce]" },
        { Id: 942028, PropertyName: "title", Value: "SMS Gönderildi" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.raporv2yuklemelisteozet_129888_value_kuikaDateRef = React.createRef();
    this.raporv2yuklemelisteozet_140956_value_kuikaDateRef = React.createRef();
    this.raporv2yuklemelisteozet_559033_value_kuikaTableRef = React.createRef();
    this.raporv2yuklemelisteozet_576980_value_kuikaDatetimeRef =
      React.createRef();
    this.raporv2yuklemelisteozet_714715_value_kuikaDatetimeRef =
      React.createRef();
    this.raporv2yuklemelisteozet_107877_value_kuikaDatetimeRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Date: [],
      SetValueOf: "",
      Rprv2_YuklemeListeOzet: [],
      Rprv2_YuklemeListeOzet_Export: [],
      ExportExcel: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("raporv2yuklemelisteozet", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.Raporv2YuklemeListeOzetPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("raporv2yuklemelisteozet", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("raporv2yuklemelisteozet", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.Raporv2YuklemeListeOzetPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  Raporv2YuklemeListeOzetPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Raporv2YuklemeListeOzetPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Raporv2YuklemeListeOzet/Raporv2YuklemeListeOzetPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.Get_Date = result?.data.get_Date;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Raporv2YuklemeListeOzetPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "raporv2yuklemelisteozet_129888_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].ayIlkGun
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].ayIlkGun
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "raporv2yuklemelisteozet_140956_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].aySonGun
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].aySonGun
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Raporv2YuklemeListeOzetPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_129888_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_140956_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Raporv2YuklemeListeOzet/Raporv2YuklemeListeOzetPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_YuklemeListeOzet = result?.data.rprv2_YuklemeListeOzet;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Raporv2YuklemeListeOzetPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_559033 =
      stateVars.Rprv2_YuklemeListeOzet ?? this.state.Rprv2_YuklemeListeOzet;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  Raporv2YuklemeListeOzetComponent_834167_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.Raporv2YuklemeListeOzetComponent_834167_onClick1_,
        "Raporv2YuklemeListeOzet",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "690718",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.Raporv2YuklemeListeOzetComponent_834167_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetComponent_834167_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "Raporv2YuklemeListeOzet",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "375410",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  Raporv2YuklemeListeOzetComponent_186535_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_129888_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_140956_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Rprv2_YuklemeListeOzet_Export
        ),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("YÜKLEME LİSTESİ", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Raporv2YuklemeListeOzet/Raporv2YuklemeListeOzetComponent_186535_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_YuklemeListeOzet_Export =
      result?.data.rprv2_YuklemeListeOzet_Export;
    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  Raporv2YuklemeListeOzetComponent_111189_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_129888_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_140956_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Raporv2YuklemeListeOzet/Raporv2YuklemeListeOzetComponent_111189_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Rprv2_YuklemeListeOzet = result?.data.rprv2_YuklemeListeOzet;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.Raporv2YuklemeListeOzetComponent_111189_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetComponent_111189_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_559033 =
      stateVars.Rprv2_YuklemeListeOzet ?? this.state.Rprv2_YuklemeListeOzet;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Raporv2YuklemeListeOzetComponent_535229_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "Tedarikci"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "YuklemeListesiv2Detaylar",
        "YuklemeId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_559033_value",
            "id"
          ),
          "Guid"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "YuklemeListesiv2Detaylar",
        "EditMode",
        ReactSystemFunctions.convertToTypeByName(false, "boolean")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.Raporv2YuklemeListeOzetComponent_535229_onClick1_,
        "Raporv2YuklemeListeOzet",
        "YuklemeListesiv2Detaylar",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.Raporv2YuklemeListeOzetComponent_535229_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  Raporv2YuklemeListeOzetComponent_535229_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "Tedarikci"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "YuklemeListesiv2DetayTedarikci",
        "YuklemeId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "raporv2yuklemelisteozet_559033_value",
            "id"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "Raporv2YuklemeListeOzet",
        "YuklemeListesiv2DetayTedarikci",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [690718, 375410, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.Raporv2YuklemeListeOzetPageInit();
    }
    if (diId == 690718) {
      isErrorOccurred =
        await this.Raporv2YuklemeListeOzetComponent_834167_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
